export const GET_ARTICLE = 'app/Article/GET_ARTICLE';
